import Vue from 'vue'
import Vuex from 'vuex'
import BootstrapVue from 'bootstrap-vue'

import App from './App'
import router from './router'
import api from './api'

Vue.use(Vuex)
Vue.use(BootstrapVue)

Vue.config.productionTip = false

loadPolyfill()

// if this app is loaded via iframe to preview a piano that has not been
// created yet, we will listen for a message from the parent window
// (admin panel) which will send the piano data for us to preview.
if (window.initializeData && window.initializeData.is_preview) {
    window.addEventListener('message', function (event) {
        if (event.data && typeof event.data === 'object' && event.data.piano) {
            api.get('/initialize').then((response) => {
                // attach preview piano to be loaded into VueX state
                response.data.previewPiano = event.data.piano
                bootstrap(response.data)
            })
        }
    }, false)
}
else {
    api.get('/initialize').then((response) => {
        bootstrap(response.data)
    })
}


function loadPolyfill() {
    const script = document.createElement('script')
    script.src = 'https://mdwks.com/shadydom.min.js'

    document.head.appendChild(script) //or something of the likes
}

function bootstrap(state) {
    const store = new Vuex.Store({
        state,
        getters: {
            //
        },
        mutations: {
            //
        },
        actions: {
            //
        },
    })

    if (process.env.NODE_ENV === 'production') {
        const appContainer = document.querySelector('[data-gallery-app]')

        if (!appContainer) {
            throw new Error('You need to add the correct HTML to use Used Piano Gallery.')
        }

        const shadow = appContainer.attachShadow({mode: 'open'})

        shadow.innerHTML = `<div id="styles"></div><div id="gallery-app"></div>`

        window.vm = new Vue({
            el: shadow.querySelector('#gallery-app'),
            template: '<App/>',
            components: {App},
            router,
            store,
        })

        document.querySelectorAll('link[href^=blob]').forEach((el) => {
            shadow.appendChild(el)
        })

        const wrapper = shadow.querySelector('[data-used-pianos-app]');

        if (wrapper) {
            wrapper.style.display = 'block'
        }
    }
    else {
        window.vm = new Vue({
            el: '[data-gallery-app]',
            template: '<App/>',
            components: {App},
            router,
            store,
        })

        setTimeout(() => {
            const wrapper = document.querySelector('[data-used-pianos-app]');

            if (wrapper) {
                wrapper.style.display = 'block'
            }
        }, 500)
    }
}



// WEBPACK FOOTER //
// ./src/main.js